<template>
  <div>
    <div v-if="isAdmin && type == 0">
      <create v-if="isUpdate" :serviceId="serviceId"></create>
      <v-divider class="mt-5"></v-divider>
    </div>
    <v-tabs v-model="tab">
      <v-tab>Message</v-tab>
      <v-tab v-if="isUpdate && type == 0">Field Order</v-tab>
    </v-tabs>
    <editor
      v-model="message"
      v-show="tab == 0"
      @input="onInput"
      :items="list"
      class="mb-5 mt-5"
    ></editor>
    <div v-show="tab == 1">
      <Right ref="right"></Right>
      <v-divider class="mb-5"></v-divider>
    </div>
  </div>
</template>

<script>
import default_fields from "../../../assets/js/default_fields";
import Create from "../../fields/service/Create.vue";
import Right from "../../fields/order/Right.vue";
import Editor from "./Editor.vue";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Create,
    Right,
    Editor,
  },
  data() {
    return {
      tab: 0,
      field: "",
      rules: [(v) => !!v || "Template Message is required."],
      message: "",
      list: [],
    };
  },
  computed: {
    isUpdate() {
      return this.$route.name == "template-update";
    },
    serviceId() {
      return this.$route.params.id;
    },
    fields() {
      return this.$store.getters.fields;
    },
    global() {
      return this.$store.getters.globalFields;
    },
    service() {
      if (this.type == 12) return this.$store.getters.serviceFields;
      return this.$store.getters.serviceFields.filter((item) => {
        return item.services && item.services.indexOf(this.id) != -1;
      });
    },
    isDispatch() {
      let id = this.$route.params.id;
      return ["dispatch-job", "technician-confirm-job"].indexOf(id) != -1;
    },
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    message(val) {
      this.$emit("input", val);
    },
    fields() {
      this.fetchList();
    },
    service() {
      this.fetchList();
    },
  },
  methods: {
    fetchList() {
      const vm = this;
      let list = [];
      let inputs = default_fields[vm.type];
      if (!inputs) inputs = [];
      if ([14, 15, 0, 16].indexOf(vm.type) != -1 || vm.isDispatch) {
        vm.global.forEach((item) => {
          list.push(item);
        });
        vm.service.forEach((item) => {
          list.push(item);
        });
        if (vm.isDispatch) {
          inputs.forEach((item) => {
            list.push(item);
          });
        } else {
          list.push({
            name: "Job Number",
            id: "Job_Number",
          });
          list.push({
            name: "Appointment Time Window",
            id: "appointment_time_window",
          });
        }
      } else {
        inputs.forEach((item) => {
          list.push(item);
        });
      }
      vm.list = list;
    },
    onInput() {
      console.log(this.message.split("<br>"));
      this.$emit("input", this.message);
    },
  },
  beforeMount() {
    const vm = this;
    vm.message = vm.value;
  },
  mounted() {
    const vm = this;
    vm.fetchList();
    if (vm.isUpdate) {
      vm.$refs.right.init(vm.serviceId);
    }
  },
};
</script>

<style></style>
